import styled from 'styled-components'
import {SIZE} from '../../const';

export const Wrapper = styled.div<{active?: boolean}>`
  position: fixed;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${(props) => props.active ? 1 : 0};
  pointer-events: ${(props) => props.active ? "auto" : "none"};
  margin: 0 !important;
  transition-property: opacity;
  transition-duration: 0.5s;
`

export const Back = styled.div`
  margin: 0;
  position: absolute;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.8);
`

export const Text = styled.div`
  color: #fff;
  font-weight: bold;
  font-size: ${SIZE.font_large};
  z-index: 1;
`
